

export const soraSteps = {
    title: '如何用 3 步使用 Sora 2 生成影片',
    sub: '幾分鐘內生成專業 AI 影片。直覺介面讓每個人都能輕鬆完成影片生成。',
    items: [
      { num: '1', title: '步驟 1：選擇輸入方式', text: '選擇文字轉影片並提供詳細提示，或圖片轉影片上傳參考圖片。描述運鏡、動作與風格。' },
      { num: '2', title: '步驟 2：設定影片參數', text: '選擇適合社群或電影風格的比例與時長（最高 15 秒）。在渲染選項中平衡速度與品質。' },
      { num: '3', title: '步驟 3：生成與下載', text: '點擊生成並預覽結果。下載高品質影片，適用於社群平台、創作專案或商用。' }
    ],
  };
